export const CookiebotConsentVuex = {
	methods: {
		addCookiebotConsentListeners() {
			window.addEventListener('CookiebotOnLoad', this.updateCookiebotConsent);
			window.addEventListener('CookiebotOnConsentReady', this.updateCookiebotConsent);
			window.addEventListener('CookiebotOnAccept', this.updateCookiebotConsent);
			window.addEventListener('CookiebotOnDecline', this.updateCookiebotConsent);
		},
		updateCookiebotConsent() {
			const choices = {}
			/* eslint-disable */
			if (typeof Cookiebot !== 'undefined' && typeof Cookiebot.consent !== 'undefined') {
				choices.preferences = Cookiebot.consent.preferences;
				choices.statistics = Cookiebot.consent.statistics;
				choices.marketing = Cookiebot.consent.marketing;
			} else {
				choices.preferences = false;
				choices.statistics = false;
				choices.marketing = false;
			}
			/* eslint-enable */
			this.$store.dispatch('consent/updateConsent', choices);
		}
	}
}